import { all, takeLatest } from 'redux-saga/effects';
import {
  CREATE_PROGRAM,
  GET_PROGRAMS,
  GET_PROGRAM_DETAILS,
  GET_PROGRAM_INFO,
  GET_PROGRAM_STATUS,
  GET_TOP_PROGRAMS,
  REVIEW_PROGRAM,
  REVIEW_PROGRAM_TO_EMPLOYEE,
  GET_CREDIT_TRANSACTIONS_FOR_PROGRAM,
  GET_EMPLOYEES_FOR_PROGRAM,
  GET_PAYMENTS_FOR_PROGRAM,
  UPDATE_PROGRAM_STATUS,
} from '../../actions/programs';
import {
  createProgramSaga,
  getAllProgramsSaga,
  getProgramDetailsSaga,
  getProgramInfoSaga,
  getProgramStatusSaga,
  getTopProgramsSaga,
  reviewProgramSaga,
  reviewProgramToEmployeeMappingSaga,
  getCreditTransactionsForProgramSaga,
  getEmployeesForProgramSaga,
  getPaymentsForProgramSaga,
  updateProgramStatusSaga,
} from './getProgramsSaga';

function* programSagas() {
  yield all([
    yield takeLatest(GET_PROGRAMS.INITIATE, getAllProgramsSaga),
    yield takeLatest(REVIEW_PROGRAM.INITIATE, reviewProgramSaga),
    yield takeLatest(GET_TOP_PROGRAMS.INITIATE, getTopProgramsSaga),
    yield takeLatest(CREATE_PROGRAM.INITIATE, createProgramSaga),
    yield takeLatest(GET_PROGRAM_INFO.INITIATE, getProgramInfoSaga),
    yield takeLatest(GET_PROGRAM_DETAILS.INITIATE, getProgramDetailsSaga),
    yield takeLatest(GET_PROGRAM_STATUS.INITIATE, getProgramStatusSaga),
    yield takeLatest(
      REVIEW_PROGRAM_TO_EMPLOYEE.INITIATE,
      reviewProgramToEmployeeMappingSaga,
    ),
    yield takeLatest(
      GET_EMPLOYEES_FOR_PROGRAM.INITIATE,
      getEmployeesForProgramSaga,
    ),
    yield takeLatest(
      GET_PAYMENTS_FOR_PROGRAM.INITIATE,
      getPaymentsForProgramSaga,
    ),
    yield takeLatest(
      GET_CREDIT_TRANSACTIONS_FOR_PROGRAM.INITIATE,
      getCreditTransactionsForProgramSaga,
    ),
    yield takeLatest(UPDATE_PROGRAM_STATUS.INITIATE, updateProgramStatusSaga),
  ]);
}

export default programSagas;
